/* eslint-disable react/no-unused-state */
import React, { Component } from "react";

import { ChevronDown, ChevronRight, Info } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { bindActionCreators } from "redux";

import "./styles.css";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import ContentLessonPlans from "../../../components/LessonPlans";
import Loading from "../../../components/Loading";
import DropdownCard from "../../../components/PedagogicalFollowUps/DropdownCard";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class ExecutionPedagogicalFollowUps extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      saving: false,
      type: 0,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: [],
      word: "",
      isCardCollapsed: false,
      alunoPCD: false,
      alunoAlfabetizado: true,
      updatingPCD: false,
      updatingAlfabetizado: false,
      isViewOnlyMode: false,
      showPCDModal: false,
      showCIDInput: false,
      cidValue: "",
      allocationId: null,
      studentId: null,
      thematicUnits: [],
      itemsWithoutAbility: [],
      studentAnswers: {},
      allocationInfo: null,
      studentInfo: null,
      habilidadesStatus: {
        EF01MA02PE: "nao-avaliado",
        EF01MA08PE: "nao-avaliado",
        EF01MA09PE: "nao-avaliado",
        EF01MA10PE: "nao-avaliado",
        EF01MA11PE: "nao-avaliado",
        EF01MA13PE: "nao-avaliado",
        EF01MA14PE: "nao-avaliado"
      }
    };
  }

  componentDidMount() {
    this.loadData();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  // A lista abre a execução em outra aba (window.open), para não perder os
  // filtros. Nesse caso fechar a aba devolve o usuário à lista intacta; sem
  // window.opener (link direto, F5 em outra aba), volta pela navegação.
  voltarParaLista = () => {
    if (window.opener && !window.opener.closed) {
      window.close();
      return;
    }
    this.props.history.push("/pedagogical-follow-ups");
  };

  handleResize = () => {
    const isMobile = window.innerWidth < 768;
    if (isMobile && !this.state.isCardCollapsed) {
      this.setState({ isCardCollapsed: true });
    } else if (!isMobile && this.state.isCardCollapsed) {
      this.setState({ isCardCollapsed: false });
    }
  };

  async loadData() {
    this.setState({ loading: true });
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    try {
      // Verificar se é modo view-only baseado no role do usuário
      const { user } = this.props;

      // Verificar se o usuário tem algum role de admin (1,2,3,4) no array user_roles
      const userRoles = user.user_roles || [];
      const adminRoles = [1, 2, 3, 4, 5];
      const hasAdminRole = userRoles.some(roleObj =>
        adminRoles.includes(roleObj.role_id)
      );
      const isViewOnlyMode = hasAdminRole;

      console.log("isViewOnlyMode:", isViewOnlyMode);

      // Extrair parâmetros da URL atual
      const currentPath = window.location.pathname;
      const pathParts = currentPath.split("/");

      // URL: /pedagogical-follow-ups/execution/1/431426
      // pathParts: ['', 'pedagogical-follow-ups', 'execution', '1', '431426']
      const allocationId = parseInt(pathParts[3]);
      const studentId = parseInt(pathParts[4]);

      this.setState({
        allocationId,
        studentId,
        isViewOnlyMode
      });

      await Promise.all([
        this.loadStudentInfo(studentId),
        this.loadQuestionList(allocationId)
      ]);

      try {
        const detailResponse = await axios.get(
          `${URL.api}pedagogical/follow-ups/executions/detail`,
          {
            params: { allocation_id: allocationId, student_id: studentId },
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }
        );

        if (detailResponse.data?.success && detailResponse.data?.data) {
          const answers = detailResponse.data.data.answers || [];
          const newStudentAnswers = {};
          answers.forEach(a => {
            newStudentAnswers[a.item_id] = a.free_response || a.option_id;
          });

          this.setState(prev => ({
            studentAnswers: { ...prev.studentAnswers, ...newStudentAnswers },
            hasExistingExecution: true
          }));

          // Atualizar habilidadesStatus com base nas respostas carregadas
          this.setState(prev => {
            const updatedStatus = { ...prev.habilidadesStatus };
            const units = prev.thematicUnits || [];
            units.forEach(unit => {
              unit.items.forEach(item => {
                const selected = newStudentAnswers[item.item_id];
                if (selected) {
                  const isFreeResponse =
                    item.options.length === 1 &&
                    item.options[0].type === "free-response";
                  if (!isFreeResponse) {
                    const status = this.getStatusFromOptionId(
                      selected,
                      item.options
                    );
                    updatedStatus[item.ability_id] = status;
                  }
                }
              });
            });
            return { habilidadesStatus: updatedStatus };
          });
        }
      } catch (e) {
        // Sem execução prévia
      }
    } catch (error) {
      console.error("Erro no carregamento geral:", error);
    } finally {
      this.setState({ loading: false });
    }
  }

  loadStudentInfo = async studentId => {
    try {
      // Executar todas as requests em paralelo
      const [studentResponse, disabilityResponse, complementResponse] =
        await Promise.allSettled([
          // Request 1: Informações básicas do estudante
          axios.get(`${URL.api}access/user/singleView/${studentId}`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),

          // Request 2: Informações de deficiência
          axios.get(`${URL.api}access/user-disability/get-by-user`, {
            params: { user_id: studentId },
            headers: { authorization: `Bearer ${this.props.user.token}` }
          }),

          // Request 3: Informações complementares (alfabetização)
          axios.get(`${URL.api}pedagogical/follow-ups/user-complement`, {
            params: { user_id: studentId },
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
        ]);

      // Processar resultado das informações básicas
      if (studentResponse.status === "fulfilled") {
        this.setState({
          studentInfo: studentResponse.value.data.data
        });
      } else {
        console.error(
          "Erro ao carregar informações básicas:",
          studentResponse.reason
        );
      }

      // Processar resultado das informações de deficiência
      if (disabilityResponse.status === "fulfilled") {
        const disabilityData = disabilityResponse.value.data.data;
        this.setState({
          alunoPCD: disabilityData?.pcd || false,
          hasReport: disabilityData?.has_report || false
        });
      } else {
        this.setState({ alunoPCD: false });
      }

      // Processar resultado das informações complementares
      if (complementResponse.status === "fulfilled") {
        const complementData = complementResponse.value.data.data;

        // Se complementData for null, o toggle fica habilitado (true)
        // Se complementData existir, verifica se is_literate é true
        if (complementData === null) {
          this.setState({
            alunoAlfabetizado: true
          });
        } else {
          this.setState({
            alunoAlfabetizado: complementData?.is_literate === true
          });
        }
      } else {
        // Em caso de erro, mantém como true (alfabetizado por padrão)
        this.setState({ alunoAlfabetizado: false });
      }
    } catch (error) {
      console.error("Erro geral ao carregar informações do estudante:", error);
    }
  };

  loadQuestionList = async allocationId => {
    try {
      // CORREÇÃO: Usar a rota correta para múltiplos IDs (mesmo sendo um único)
      const params = new URLSearchParams();
      params.append("allocation_ids[]", allocationId);

      const allocationUrl = `${
        URL.api
      }pedagogical/follow-ups/allocations/information?${params.toString()}`;

      console.log("🔗 URL da alocação:", allocationUrl);

      const allocationResponse = await axios.get(allocationUrl, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      });

      console.log("📦 Resposta da alocação:", allocationResponse.data);

      // Verificar se a resposta foi bem-sucedida
      if (!allocationResponse.data?.success) {
        throw new Error("Erro ao buscar informações da alocação");
      }

      // Acessar os dados corretamente (agora vem dentro de 'data')
      const allocationData = allocationResponse.data.data;

      // Como é uma única alocação, pegamos o primeiro item do array allocations
      const allocationInfo =
        allocationData.allocations && allocationData.allocations[0];

      if (!allocationInfo) {
        throw new Error("Dados da alocação não encontrados");
      }

      // Salvar informações da alocação no estado
      this.setState({
        allocationInfo
      });

      const followUpId = allocationInfo.follow_up_id;

      if (!followUpId) {
        throw new Error("Follow-up ID não encontrado na alocação");
      }

      // Agora buscar a lista de questões usando o followUpId
      const questionUrl = `${URL.api}pedagogical/follow-ups/${followUpId}/question-list`;

      const response = await axios.get(questionUrl, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      });

      if (!response.data?.success) {
        throw new Error("Erro ao buscar lista de questões");
      }

      const {
        thematic_units: thematicUnits,
        items_without_ability: itemsWithoutAbility
      } = response.data.data; // Nota: os dados estão em response.data.data

      this.setState({
        thematicUnits: thematicUnits || [],
        itemsWithoutAbility: itemsWithoutAbility || []
      });

      // Debug: verificar as opções disponíveis
      console.log("Unidades temáticas carregadas:", thematicUnits);
      if (thematicUnits && thematicUnits.length > 0) {
        thematicUnits.forEach((unit, index) => {
          console.log(`Unidade ${index + 1}: ${unit.thematic_unit_name}`);
          if (unit.items && unit.items.length > 0) {
            unit.items.forEach((item, itemIndex) => {
              console.log(`  Item ${itemIndex + 1}: ${item.ability_name}`);
              console.log(`  Opções:`, item.options);
            });
          }
        });
      }

      // Inicializar estados sincronizados
      if (this.initializeSyncedStates) {
        this.initializeSyncedStates(thematicUnits || []);
      }
    } catch (error) {
      console.error("❌ Erro ao carregar lista de questões:", error);
      console.error("Detalhes do erro:", error.response?.data);
      toastr.error("Erro", "Falha ao carregar os dados da avaliação.");
    }
  };

  toggleCardCollapse = () => {
    this.setState(prevState => ({
      isCardCollapsed: !prevState.isCardCollapsed
    }));
  };

  handleToggleAlunoPCD = () => {
    const { studentId, isViewOnlyMode, alunoPCD } = this.state;

    if (isViewOnlyMode) {
      toastr.warning(
        "Atenção",
        "Você não tem permissão para alterar essas informações."
      );
      return;
    }

    const newValue = !alunoPCD;

    if (newValue === true) {
      // Ativando: mostrar modal para escolher com/sem laudo
      this.setState({ showPCDModal: true, showCIDInput: false, cidValue: "" });
    } else {
      // Desativando: enviar pcd=false, has_report=false
      this.updatePCDStatus(false, null, false);
    }
  };

  updatePCDStatus = async (pcdValue, cidValue, hasReportValue) => {
    const { studentId } = this.state;
    const { user } = this.props;

    this.setState({ updatingPCD: true });

    try {
      const payload = {
        user_id: studentId,
        pcd: pcdValue,
        cid: cidValue,
        has_report: hasReportValue // ← novo campo
      };

      const response = await axios.post(
        `${URL.api}access/user-disability/upsert`,
        payload,
        { headers: { authorization: `Bearer ${user.token}` } }
      );

      if (!response.data?.success) {
        throw new Error(response.data?.error || "Erro ao atualizar PCD");
      }

      // Atualiza estado com os novos valores
      this.setState({
        alunoPCD: pcdValue,
        hasReport: hasReportValue,
        updatingPCD: false
      });
      toastr.success("Sucesso", "Informação de PCD atualizada com sucesso!");
    } catch (error) {
      console.error("Erro ao persistir PCD:", error);
      toastr.error(
        "Erro",
        error.response?.data?.error || error.message || "Erro ao atualizar PCD"
      );
      this.setState({ updatingPCD: false });
    }
  };

  handlePCDModalComLaudo = () => {
    const { showCIDInput, cidValue } = this.state;

    if (!showCIDInput) {
      // Primeiro clique: mostrar input de CID
      this.setState({ showCIDInput: true });
      return;
    }

    // Segundo clique (com input visível): salvar com has_report = true
    this.setState({ showPCDModal: false, showCIDInput: false });
    const cidToSend = cidValue?.trim() || null;
    this.updatePCDStatus(true, cidToSend, true); // ← has_report = true
  };

  handlePCDModalSemLaudo = () => {
    this.setState({ showPCDModal: false, showCIDInput: false });
    this.updatePCDStatus(true, null, false); // ← has_report = false
  };

  handleClosePCDModal = () => {
    this.setState({ showPCDModal: false, showCIDInput: false, cidValue: "" });
  };

  handleToggleAlunoAlfabetizado = () => {
    const { studentId, isViewOnlyMode } = this.state;
    const { user } = this.props;

    // Não permitir alteração em modo view-only
    if (isViewOnlyMode) {
      toastr.warning(
        "Atenção",
        "Você não tem permissão para alterar essas informações."
      );
      return;
    }

    const newValue = !this.state.alunoAlfabetizado;

    // Set loading state
    this.setState({ updatingAlfabetizado: true });

    (async () => {
      try {
        const payload = {
          user_id: studentId,
          is_literate: newValue
        };

        const response = await axios.post(
          `${URL.api}access/user_complement/upsert`,
          payload,
          { headers: { authorization: `Bearer ${user.token}` } }
        );

        if (!response.data?.success) {
          throw new Error(
            response.data?.error || "Erro ao atualizar alfabetizado"
          );
        }

        // Update UI only on success
        this.setState({
          alunoAlfabetizado: newValue,
          updatingAlfabetizado: false
        });
      } catch (error) {
        console.error("Erro ao persistir alfabetizado:", error);
        toastr.error(
          "Erro",
          error.response?.data?.error ||
            error.message ||
            "Erro ao atualizar alfabetizado"
        );
        this.setState({ updatingAlfabetizado: false });
      }
    })();
  };

  // Função para inicializar estados sincronizados
  initializeSyncedStates = thematicUnits => {
    const initialHabilidadesStatus = {};
    const initialStudentAnswers = {};

    thematicUnits.forEach(unit => {
      unit.items.forEach(item => {
        // Inicializar habilidadesStatus com "nao-avaliado"
        initialHabilidadesStatus[item.ability_id] = "nao-avaliado";
        // Inicializar studentAnswers com "nao-avaliado"
        initialStudentAnswers[item.item_id] = "nao-avaliado";
      });
    });

    this.setState(prevState => ({
      habilidadesStatus: {
        ...prevState.habilidadesStatus,
        ...initialHabilidadesStatus
      },
      studentAnswers: {
        ...prevState.studentAnswers,
        ...initialStudentAnswers
      }
    }));
  };

  // Função para mapear status de habilidade para option_id
  getOptionIdFromStatus = (status, options) => {
    if (!options || options.length === 0) return "nao-avaliado";

    // Mapear status para títulos comuns
    const statusMap = {
      desenvolveu: ["desenvolveu", "desenvolvida", "sim", "adequado"],
      "desenvolveu-parcialmente": [
        "desenvolveu parcialmente",
        "parcialmente",
        "em desenvolvimento"
      ],
      "nao-desenvolveu": [
        "não desenvolveu",
        "não desenvolvida",
        "não",
        "inadequado"
      ],
      "nao-avaliado": ["não avaliado", "não avaliada"]
    };

    const statusTitles = statusMap[status] || [];

    for (const option of options) {
      const optionTitle = option.title.toLowerCase();
      if (statusTitles.some(title => optionTitle.includes(title))) {
        return option.id;
      }
    }

    return "nao-avaliado";
  };

  // Função para mapear option_id para status de habilidade
  getStatusFromOptionId = (optionId, options) => {
    if (!options || options.length === 0 || optionId === "nao-avaliado") {
      return "nao-avaliado";
    }

    const option = options.find(
      opt => opt.id.toString() === optionId.toString()
    );
    if (!option) return "nao-avaliado";

    const title = option.title.toLowerCase();

    if (
      title.includes("desenvolveu") &&
      !title.includes("parcialmente") &&
      !title.includes("não")
    ) {
      return "desenvolveu";
    }
    if (
      title.includes("parcialmente") ||
      title.includes("em desenvolvimento")
    ) {
      return "desenvolveu-parcialmente";
    }
    if (title.includes("não")) {
      return "nao-desenvolveu";
    }

    return "nao-avaliado";
  };

  handleRowClick = (habilidade, item) => {
    // Só funciona no mobile
    const isMobile = window.innerWidth < 768;
    if (!isMobile) return;

    const codigo = habilidade.split(" - ")[0];

    this.setState(prevState => {
      const currentStatus =
        prevState.habilidadesStatus[codigo] || "nao-avaliado";
      let nextStatus;

      switch (currentStatus) {
        case "nao-avaliado":
          nextStatus = "desenvolveu";
          break;
        case "desenvolveu":
          nextStatus = "desenvolveu-parcialmente";
          break;
        case "desenvolveu-parcialmente":
          nextStatus = "nao-desenvolveu";
          break;
        case "nao-desenvolveu":
          nextStatus = "desenvolveu";
          break;
        default:
          nextStatus = "desenvolveu";
      }

      // Sincronizar com studentAnswers
      const newStudentAnswers = { ...prevState.studentAnswers };
      if (item && item.options) {
        const optionId = this.getOptionIdFromStatus(nextStatus, item.options);
        newStudentAnswers[item.item_id] = optionId;
      }

      return {
        habilidadesStatus: {
          ...prevState.habilidadesStatus,
          [codigo]: nextStatus
        },
        studentAnswers: newStudentAnswers
      };
    });
  };

  handleDesktopSelectChange = (codigo, value) => {
    this.setState(prevState => ({
      habilidadesStatus: {
        ...prevState.habilidadesStatus,
        [codigo]: value
      }
    }));
  };

  handleItemAnswerChange = (itemId, optionId, item) => {
    // Não permitir alteração em modo view-only
    if (this.state.isViewOnlyMode) {
      toastr.warning(
        "Atenção",
        "Você não tem permissão para alterar essas informações."
      );
      return;
    }

    this.setState(prevState => {
      const newStudentAnswers = {
        ...prevState.studentAnswers,
        [itemId]: optionId
      };

      // Sincronizar com habilidadesStatus
      const newHabilidadesStatus = { ...prevState.habilidadesStatus };
      if (item && item.options) {
        const isFreeResponse =
          item.options.length === 1 && item.options[0].type === "free-response";
        if (!isFreeResponse) {
          const status = this.getStatusFromOptionId(optionId, item.options);
          newHabilidadesStatus[item.ability_id] = status;
        }
      }

      return {
        studentAnswers: newStudentAnswers,
        habilidadesStatus: newHabilidadesStatus
      };
    });
  };

  getUnitColor = index => {
    const colors = ["#b3d9ff", "#ffcc99", "#d4f4dd", "#ffb3d9", "#d9b3ff"];
    return colors[index % colors.length];
  };

  getStatusStyle = codigo => {
    const status = this.state.habilidadesStatus[codigo];
    switch (status) {
      case "desenvolveu":
        return {
          backgroundColor: "#d4edda",
          borderLeft: "4px solid #28a745",
          color: "#155724"
        };
      case "desenvolveu-parcialmente":
        return {
          backgroundColor: "#fff3cd",
          borderLeft: "4px solid #ffc107",
          color: "#856404"
        };
      case "nao-desenvolveu":
        return {
          backgroundColor: "#f8d7da",
          borderLeft: "4px solid #dc3545",
          color: "#721c24"
        };
      case "nao-avaliado":
      default:
        return {
          backgroundColor: "transparent",
          borderLeft: "none",
          color: "inherit"
        };
    }
  };

  getStatusIcon = codigo => {
    const status = this.state.habilidadesStatus[codigo];
    switch (status) {
      case "desenvolveu":
        return "✓";
      case "desenvolveu-parcialmente":
        return "◐";
      case "nao-desenvolveu":
        return "✗";
      case "nao-avaliado":
      default:
        return "○";
    }
  };

  getDropdownClass = (itemId, options) => {
    const selectedOptionId = this.state.studentAnswers[itemId];

    if (!selectedOptionId || selectedOptionId === "nao-avaliado") {
      return "form-control form-control-sm";
    }

    const status = this.getStatusFromOptionId(selectedOptionId, options);

    switch (status) {
      case "desenvolveu":
        return "form-control form-control-sm dropdown-desenvolveu";
      case "desenvolveu-parcialmente":
        return "form-control form-control-sm dropdown-parcialmente";
      case "nao-desenvolveu":
        return "form-control form-control-sm dropdown-nao-desenvolveu";
      default:
        return "form-control form-control-sm";
    }
  };

  handleSaveExecution = async () => {
    const { user } = this.props;
    const {
      allocationId,
      studentId,
      studentAnswers,
      thematicUnits,
      itemsWithoutAbility,
      alunoAlfabetizado
    } = this.state;

    if (!allocationId || !studentId) {
      toastr.error("Erro", "Dados da alocação ou estudante não encontrados.");
      return;
    }

    // --- 1. Se aluno NÃO é alfabetizado, garantir que o backend saiba disso ---
    if (alunoAlfabetizado === false) {
      this.setState({ saving: true });
      try {
        const payload = {
          user_id: studentId,
          is_literate: false
        };
        const response = await axios.post(
          `${URL.api}access/user_complement/upsert`,
          payload,
          { headers: { authorization: `Bearer ${user.token}` } }
        );
        if (!response.data?.success) {
          throw new Error(
            response.data?.error || "Erro ao definir não alfabetizado"
          );
        }
      } catch (error) {
        console.error("Erro ao persistir não alfabetizado:", error);
        toastr.error(
          "Erro",
          error.response?.data?.error ||
            error.message ||
            "Não foi possível registrar o aluno como não alfabetizado. O salvamento foi cancelado."
        );
        this.setState({ saving: false });
        return; // Aborta o salvamento
      }
    }

    // --- 2. Montar e enviar respostas (lógica original) ---
    const allItems = [];
    thematicUnits.forEach(unit => {
      unit.items.forEach(item => allItems.push(item));
    });
    itemsWithoutAbility.forEach(item => allItems.push(item));

    const answers = [];
    Object.keys(studentAnswers).forEach(itemId => {
      const answer = studentAnswers[itemId];
      const item = allItems.find(
        i => i.item_id.toString() === itemId.toString()
      );
      if (!item || !answer || answer === "nao-avaliado") return;

      const isFreeResponse =
        item.options.length === 1 && item.options[0].type === "free-response";

      if (isFreeResponse) {
        if (answer.trim()) {
          answers.push({
            item_id: parseInt(itemId),
            option_id: item.options[0].id,
            free_text: answer
          });
        }
      } else {
        answers.push({
          item_id: parseInt(itemId),
          option_id: parseInt(answer)
        });
      }
    });

    if (answers.length === 0) {
      toastr.warning(
        "Atenção",
        "Nenhuma resposta foi preenchida. Preencha pelo menos uma resposta antes de finalizar."
      );
      this.setState({ saving: false });
      return;
    }

    try {
      const payload = {
        allocation_id: allocationId,
        student_id: studentId,
        teacher_id: user.user.id,
        answers
      };

      const response = await axios.post(
        `${URL.api}pedagogical/follow-ups/executions/save`,
        payload,
        { headers: { authorization: `Bearer ${user.token}` } }
      );

      if (response.data.success) {
        toastr.success("Sucesso", response.data.message);
        // O evento "storage" chega na aba da lista, que recarrega o status
        // dos alunos sem mexer nos filtros.
        try {
          localStorage.setItem(
            "pedagogical_followups_execution_saved",
            String(Date.now())
          );
        } catch (e) {
          // ignore storage errors
        }
        this.voltarParaLista();
      } else {
        toastr.error(
          "Erro",
          response.data.message || "Erro ao salvar acompanhamento pedagógico."
        );
      }
    } catch (error) {
      console.error("Erro ao salvar acompanhamento:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Erro ao salvar acompanhamento pedagógico.";
      toastr.error("Erro", errorMessage);
    } finally {
      this.setState({ saving: false });
    }
  };

  handleDownloadPDF = async () => {
    const { allocationInfo } = this.state;
    const followUpId = allocationInfo?.follow_up_id;

    if (!followUpId) {
      toastr.warning("Atenção", "ID do planejamento não disponível.");
      return;
    }

    try {
      const response = await axios.get(
        `${URL.api}pedagogical/follow-ups/${followUpId}/download-pdf`,
        {
          responseType: "blob",
          headers: { authorization: `Bearer ${this.props.user.token}` }
        }
      );

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank"); // Abre em nova aba
      // Libera a URL após um breve tempo para não ocupar memória
      setTimeout(() => window.URL.revokeObjectURL(url), 100);

      toastr.success("Sucesso", "PDF aberto em nova aba.");
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      toastr.error("Erro", "Não foi possível abrir o PDF.");
    }
  };

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;
    const { allocationInfo, studentInfo } = this.state;

    // Customizar breadcrumb para mostrar navegação correta
    const breadcrumbItems = [
      {
        path: "/pedagogical-follow-ups",
        to: "/pedagogical-follow-ups",
        name: "Acompanhamento Pedagógico"
      }
    ];

    return (
      <>
        <Breadcrumb current={this.props.currentRoute} items={breadcrumbItems} />
        {this.state.loading ? (
          <div className="p-4">
            <Loading />
          </div>
        ) : (
          <>
            <div className="mt-0">
              <div
                className={`card shadow-sm ${
                  this.state.isCardCollapsed ? "collapsed" : ""
                }`}
              >
                <div
                  className="card-header bg-primary text-white d-flex align-items-center"
                  onClick={this.toggleCardCollapse}
                  style={{ cursor: "pointer" }}
                >
                  <div className="mr-2">
                    {this.state.isCardCollapsed ? (
                      <ChevronRight size={20} />
                    ) : (
                      <ChevronDown size={20} />
                    )}
                  </div>
                  {this.state.isCardCollapsed ? (
                    <div className="d-flex align-items-center w-100">
                      <div className="flex-grow-1">
                        <h5 className="mb-0">
                          {studentInfo?.user?.name
                            ? `${studentInfo.user.name} ${
                                studentInfo.user.surname || ""
                              }`.trim()
                            : "Carregando..."}
                        </h5>
                        <small className="text-white">
                          {allocationInfo?.room_name || "Carregando..."}
                        </small>
                      </div>
                    </div>
                  ) : (
                    <h5 className="mb-0 d-flex align-items-center">
                      Acompanhamento Pedagógico
                    </h5>
                  )}
                </div>
                {!this.state.isCardCollapsed && (
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Nome do(a) Estudante
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={
                            studentInfo?.user?.name
                              ? `${studentInfo.user.name} ${
                                  studentInfo.user.surname || ""
                                }`.trim()
                              : "Carregando..."
                          }
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Turma
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={allocationInfo?.room_name || "Carregando..."}
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Disciplina
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={
                            allocationInfo?.discipline_name || "Carregando..."
                          }
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Escola
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={allocationInfo?.school_name || "Carregando..."}
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Mês
                        </label>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          value={allocationInfo?.month_name || ""}
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-3 col-md-6 col-6 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Data de Início
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={allocationInfo?.start_date || ""}
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                      <div className="col-lg-3 col-md-6 col-6 mb-3">
                        <label className="form-label font-weight-bold text-muted">
                          Data de Fim
                        </label>
                        <input
                          type="date"
                          className="form-control form-control-sm"
                          value={allocationInfo?.end_date || ""}
                          readOnly
                          style={{
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #e9ecef"
                          }}
                        />
                      </div>
                      {false && (
                        <>
                          <div className="col-lg-3 col-md-6 col-6 mb-3">
                            <label className="form-label font-weight-bold text-muted">
                              Estudantes Frequentando
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value="28"
                              readOnly
                              style={{
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e9ecef"
                              }}
                            />
                          </div>
                          <div className="col-lg-3 col-md-6 col-6 mb-3">
                            <label className="form-label font-weight-bold text-muted">
                              Estudantes com Deficiência
                            </label>
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value="3"
                              readOnly
                              style={{
                                backgroundColor: "#f8f9fa",
                                border: "1px solid #e9ecef"
                              }}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div>
              <div className="card shadow-sm">
                <div
                  className="card-header bg-primary text-white d-flex align-items-center justify-content-between"
                  onClick={this.toggleCardCollapse}
                  style={{ cursor: "pointer" }}
                >
                  <div className="d-flex align-items-center">
                    <div className="mr-2">
                      {this.state.isCardCollapsed ? (
                        <ChevronRight size={20} />
                      ) : (
                        <ChevronDown size={20} />
                      )}
                    </div>
                    <h5 className="mb-0">Acompanhamento das Habilidades</h5>
                  </div>
                  {!this.state.isCardCollapsed && (
                    <button
                      className="btn btn-sm btn-outline-light"
                      onClick={e => {
                        e.stopPropagation();
                        this.handleDownloadPDF();
                      }}
                    >
                      Obter Ajuda
                    </button>
                  )}
                </div>
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-12">
                      <div className="d-flex align-items-center">
                        <div className="d-flex align-items-center mr-5">
                          <label className="form-label font-weight-bold text-muted mr-3 mb-0">
                            Estudante PCD
                          </label>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="toggleAlunoPCD"
                              checked={this.state.alunoPCD}
                              onChange={this.handleToggleAlunoPCD}
                              disabled={
                                this.state.updatingPCD ||
                                this.state.isViewOnlyMode
                              }
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="toggleAlunoPCD"
                            ></label>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <label className="form-label font-weight-bold text-muted mr-3 mb-0">
                            Estudante alfabetizado
                          </label>
                          <div className="custom-control custom-switch">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="toggleAlunoAlfabetizado"
                              checked={this.state.alunoAlfabetizado}
                              onChange={this.handleToggleAlunoAlfabetizado}
                              disabled={
                                this.state.updatingAlfabetizado ||
                                this.state.isViewOnlyMode
                              }
                            />
                            <label
                              className="custom-control-label"
                              htmlFor="toggleAlunoAlfabetizado"
                            ></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row d-md-none">
                    <div className="col-12">
                      <div className="card bg-light">
                        <div className="card-body py-3">
                          <h6 className="card-title mb-2">Legenda:</h6>
                          <div className="row">
                            <div className="col-6 mb-2">
                              <div className="d-flex align-items-start">
                                <div
                                  className="legend-color-circle"
                                  style={{ backgroundColor: "#28a745" }}
                                ></div>
                                <span>Desenvolveu</span>
                              </div>
                            </div>

                            <div className="col-6 mb-2">
                              <div className="d-flex align-items-start">
                                <div
                                  className="legend-color-circle"
                                  style={{ backgroundColor: "#ffc107" }}
                                ></div>
                                <span>Desenvolveu Parcialmente</span>
                              </div>
                            </div>

                            <div className="col-6 mb-2">
                              <div className="d-flex align-items-start">
                                <div
                                  className="legend-color-circle"
                                  style={{ backgroundColor: "#dc3545" }}
                                ></div>
                                <span>Não desenvolveu</span>
                              </div>
                            </div>

                            <div className="col-6 mb-2">
                              <div className="d-flex align-items-start">
                                <div
                                  className="legend-color-circle"
                                  style={{ backgroundColor: "#6c757d" }}
                                ></div>
                                <span>Não avaliado</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          <th
                            className="text-center align-middle"
                            style={{ width: "5%" }}
                          >
                            #
                          </th>
                          <th
                            className="text-center align-middle"
                            style={{ width: "18%" }}
                          >
                            {allocationInfo?.discipline_name === "Linguagem" ||
                            allocationInfo?.discipline_name ===
                              "Língua Portuguesa"
                              ? "PRÁTICAS DE LINGUAGEM"
                              : "UNIDADES TEMÁTICAS"}
                          </th>
                          <th
                            className="text-center align-middle"
                            style={{ width: "54%" }}
                          >
                            CÓDIGO E DESCRIÇÃO DA HABILIDADE
                          </th>
                          <th
                            className="text-center align-middle d-none d-md-table-cell"
                            style={{ width: "22%" }}
                          >
                            AVALIAÇÃO
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.thematicUnits.map((unit, unitIndex) =>
                          unit.items.map((item, itemIndex) => (
                            <tr
                              key={`${unit.thematic_unit_id}-${item.item_id}`}
                              className="d-md-table-row mobile-row"
                              data-group={unitIndex + 1}
                              onClick={() =>
                                this.handleRowClick(
                                  `${item.ability_id} - ${item.ability_name}`,
                                  item
                                )
                              }
                            >
                              {itemIndex === 0 && (
                                <td
                                  className="text-center align-middle"
                                  rowSpan={unit.items.length}
                                >
                                  {unitIndex + 1}
                                </td>
                              )}
                              {itemIndex === 0 && (
                                <td
                                  className="text-center align-middle"
                                  rowSpan={unit.items.length}
                                  style={{
                                    backgroundColor:
                                      this.getUnitColor(unitIndex)
                                  }}
                                >
                                  <strong>
                                    {unit.thematic_unit_name.toUpperCase()}
                                  </strong>
                                </td>
                              )}
                              <td
                                className="d-md-table-cell"
                                style={this.getStatusStyle(item.ability_id)}
                              >
                                <div className="d-flex align-items-center">
                                  <span
                                    className="d-md-none mr-2"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "bold"
                                    }}
                                  >
                                    {this.getStatusIcon(item.ability_id)}
                                  </span>
                                  <div>
                                    {item.ability_code && (
                                      <strong>{item.ability_code} - </strong>
                                    )}
                                    {item.complements
                                      ? item.complements
                                      : item.ability_name}
                                  </div>
                                </div>
                              </td>
                              <td className="text-center d-none d-md-table-cell align-middle">
                                {item.options.length === 1 &&
                                item.options[0].type === "free-response" ? (
                                  <textarea
                                    className="form-control form-control-sm"
                                    rows="3"
                                    placeholder={item.options[0].title}
                                    value={
                                      this.state.studentAnswers[item.item_id] ||
                                      ""
                                    }
                                    onChange={e =>
                                      this.handleItemAnswerChange(
                                        item.item_id,
                                        e.target.value,
                                        item
                                      )
                                    }
                                    disabled={this.state.isViewOnlyMode}
                                  />
                                ) : (
                                  <select
                                    className={this.getDropdownClass(
                                      item.item_id,
                                      item.options
                                    )}
                                    value={
                                      this.state.studentAnswers[item.item_id] ||
                                      "nao-avaliado"
                                    }
                                    onChange={e =>
                                      this.handleItemAnswerChange(
                                        item.item_id,
                                        e.target.value,
                                        item
                                      )
                                    }
                                    disabled={this.state.isViewOnlyMode}
                                  >
                                    <option value="nao-avaliado">
                                      Não avaliado
                                    </option>
                                    {item.options.map(option => (
                                      <option key={option.id} value={option.id}>
                                        {option.title}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            {this.state.itemsWithoutAbility.length > 0 && (
              <div>
                {this.state.itemsWithoutAbility.map(item => (
                  <DropdownCard
                    key={item.item_id}
                    title={item.description}
                    options={item.options}
                    value={this.state.studentAnswers[item.item_id] || ""}
                    disabled={this.state.isViewOnlyMode}
                    onSelectionChange={optionId => {
                      // Não permitir alteração em modo view-only
                      if (this.state.isViewOnlyMode) {
                        toastr.warning(
                          "Acesso Restrito",
                          "Você não tem permissão para editar este campo."
                        );
                        return;
                      }

                      this.setState(prevState => ({
                        studentAnswers: {
                          ...prevState.studentAnswers,
                          [item.item_id]: optionId
                        }
                      }));
                    }}
                  />
                ))}
              </div>
            )}

            <div className="d-flex justify-content-end mb-4">
              <div className="d-flex">
                <Button
                  color="secondary"
                  className="mr-2"
                  onClick={this.voltarParaLista}
                >
                  Cancelar
                </Button>
                {!this.state.isViewOnlyMode && (
                  <Button
                    color="primary"
                    onClick={this.handleSaveExecution}
                    disabled={this.state.saving}
                  >
                    {this.state.saving ? (
                      <>
                        <i className="fa fa-spinner fa-spin" /> Salvando...
                      </>
                    ) : this.state.hasExistingExecution ? (
                      "Editar"
                    ) : (
                      "Finalizar"
                    )}
                  </Button>
                )}
              </div>
            </div>
          </>
        )}

        {/* Modal PCD */}
        <Modal
          isOpen={this.state.showPCDModal}
          toggle={this.handleClosePCDModal}
          centered
        >
          <ModalHeader toggle={this.handleClosePCDModal}>
            Estudante com Deficiência
          </ModalHeader>
          <ModalBody>
            {!this.state.showCIDInput ? (
              <p className="p-3 m-0">
                O estudante possui laudo médico com CID?
              </p>
            ) : (
              <div className="form-group p-3 m-0">
                CID do Laudo{" "}
                <span className="text-muted font-weight-normal">
                  (opcional)
                </span>
                <input
                  type="text"
                  className="form-control"
                  id="cidInput"
                  placeholder="Ex: F84.0, G80.0, etc."
                  value={this.state.cidValue}
                  onChange={e => this.setState({ cidValue: e.target.value })}
                />
                <small className="form-text text-muted">
                  Informe o código CID do laudo médico.
                </small>
              </div>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.handleClosePCDModal}>
              Cancelar
            </Button>
            {!this.state.showCIDInput ? (
              <>
                <Button color="warning" onClick={this.handlePCDModalSemLaudo}>
                  Sem Laudo
                </Button>
                <Button color="primary" onClick={this.handlePCDModalComLaudo}>
                  Com Laudo
                </Button>
              </>
            ) : (
              <Button color="primary" onClick={this.handlePCDModalComLaudo}>
                Salvar
              </Button>
            )}
          </ModalFooter>
        </Modal>

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ logout, setObj }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExecutionPedagogicalFollowUps);
